import Http from '../libs/http';

export default {
  couponExchange(data) {
    return Http.post('/coupon_exchange', data);
  },

  peerCouponBriefQuery() {
    return Http.post('/peer_coupon_brief_query', {});
  },

  /* couponFirstOrderQuery() {
    return Http.post('/coupon_first_order_query', {});
  }, */

  orderCouponQuery(params) {
    return Http.post('/order_coupon_brief_query', params);
  },

  orderCouponExchange(params) {
    return Http.post('/order_coupon_exchange', params, { noToast: true });
  },

  getValue(event) {
    let value = event.target.value.replace(/\W/ig, '').replace(/_/ig, '');
    value = value.length > 10 ? value.substring(0, 10) : value;
    value = value.toUpperCase();
    return value;
  },
};



// WEBPACK FOOTER //
// ./src/services/coupon-service.js